import { useAuth0, User as Auth0User } from '@auth0/auth0-react';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { apiConfigs } from '../../../api/APIConfigs';
import { RhEvent } from '../../../api/models/RhEvent';
import { User } from '../../../api/models/User';
import { RootState } from '../../../model/store';
import { routes } from '../../../route-list';
import { useAsyncRequest } from '../../../util/use-async-request';
import { useRequest } from '../../../util/use-request';
import { HomeScreen } from '../components/HomeScreen';

export type HomeProps = {
  /** Profile of the current user from store */
  profile: User | null;
  /** User object from auth0 */
  user: Auth0User | undefined;
  /** Whether or not the events are being fetched */
  loadingEvents: boolean;
  /** The list of upcoming events */
  upcomingEvents: RhEvent[];
  /** called when user wants to invite someone */
  userClickedInviteUser: () => void;
  /** called when the user clicks "add" under Livestreams */
  userClickedAddEventButton: () => void;
  /** called when the user clicks a single event from the list of "Upcoming Livestreams" */
  userClickedAnEvent: (id: string) => void;
  /** called when the user clicks the "Send Notification" button */
  userClickedSendNotificationButton: () => void;
};

export const HomeContainer = () => {
  const profile = useSelector((state: RootState) => state.user.profile);

  const history = useHistory();
  const { user } = useAuth0();
  const request = useRequest();

  const { loading: loadingEvents, data: upcomingEvents } = useAsyncRequest(
    useCallback(() => request<RhEvent[]>(apiConfigs.getUpcomingEvents()), [request])
  );

  return (
    <HomeScreen
      loadingEvents={loadingEvents}
      upcomingEvents={upcomingEvents || []}
      user={user}
      profile={profile}
      userClickedInviteUser={() => {
        history.push(routes.PEOPLE);
      }}
      userClickedAddEventButton={() => {
        history.push(routes.EVENTS__ADD);
      }}
      userClickedAnEvent={id => {
        history.push(routes.EVENTS__VIEW(id));
      }}
      userClickedSendNotificationButton={() => {
        history.push(routes.COMMUNICATIONS);
      }}
    />
  );
};
